/**
 * Base64 encoding/decoding utilities that properly handle UTF-8 characters
 * Uses modern Web APIs and base64-js for optimal performance
 */

import { fromByteArray, toByteArray } from "base64-js";

/**
 * Encode a string to base64 with proper UTF-8 handling
 * @param str - The string to encode
 * @returns Base64 encoded string
 */
export function b64EncodeUnicode(str: string): string {
  // Use TextEncoder to convert string to UTF-8 bytes, then encode to base64
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);
  return fromByteArray(bytes);
}

/**
 * Decode a base64 string to UTF-8 with proper character handling
 * @param str - The base64 string to decode
 * @returns UTF-8 decoded string
 */
export function b64DecodeUnicode(str: string): string {
  // Decode base64 to bytes, then use TextDecoder to convert to UTF-8 string
  const bytes = toByteArray(str);
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(bytes);
}
